// request
import {
  requireCustomerQuestionParams,
  requireRobotQuestionParams,
} from "@/app/utils/requireStoreParams";
import { robotChat, RobotChatResponseType } from "@/app/api/robot";
import { saveRobotInfo } from "@/app/api/robot/chatContent";

//type
import {
  QuestionContentType,
  QuestionType,
  ReplyActionEnum,
  ChatContentType,
  TagTypeEnum,
  TemplateFlagEnum,
  ComponentTypeEnum,
} from "@/app/types/typeConfig/chatQuestion";
import {
  RobotChatPropsType,
  ReportParentContentEnum,
} from "@/app/types/typeConfig/report";

import { requireIssueTypeSet, NoFoundKnowledgeId } from "@/const/issueType";
import {
  IssueChildrenType,
  IssueItemType,
} from "@/app/types/typeConfig/issueType";
import { MessageSender, RobotMessageType } from "@/app/store/types";
export async function handleRobotChat(
  params: RobotChatPropsType,
  {
    customerMessage,
    dialog,
    parentContentInfo,
    questionName,
    rootSourceType,
  }: {
    rootSourceType?: TagTypeEnum;
    customerMessage: string;
    dialog?: boolean;
    questionName?: string;
    parentContentInfo?: {
      parentContent: string;
      parentContentId: string;
      parentContentType: ReportParentContentEnum;
    };
  },
  isAuthenticated?: boolean,
): Promise<ChatContentType[] | RobotChatResponseType> {
  try {
    const data: RobotChatResponseType = await robotChat(params);
    if (dialog && data.error) {
      return Promise.resolve({ ...data, error: true, reply: data.reply });
    } else {
      let chatContentData:
        | QuestionContentType
        | QuestionType[]
        | IssueChildrenType[] = [];
      let compDirName = "";
      let type = ComponentTypeEnum.Robot;
      let robotMessage = "";
      let issueTypeItem = null;
      const IssueTypeSet = requireIssueTypeSet();

      switch (data.action) {
        case ReplyActionEnum.answerQuestion:
          compDirName = TemplateFlagEnum.AnswerQuestion;
          chatContentData = data;
          // 掉一次保存机器人回答接口（只在有登录态时调用）
          robotMessage = data.reply;
          if (isAuthenticated) {
            await saveRobotInfo([
              {
                clientId: params.data.userId || "",
                clientTimestamp: params.behaviorCollect.createTime || 0,
                content: JSON.stringify({
                  text: params.behaviorCollect.content,
                }),
                senderType: MessageSender.USER,
                type: "text",
              },
              {
                clientId: params.data.userId || "",
                clientTimestamp: Date.now(),
                senderType: MessageSender.ROBOT,
                content: JSON.stringify({
                  text: data.reply,
                  messageType: RobotMessageType.ROBOT_NORMAL_REPLY,
                }),
                type: "text",
              },
            ]);
          }
          break;
        case ReplyActionEnum.templateFlag:
          console.log("data.templateFlag", IssueTypeSet[data.templateFlag]);
          if (IssueTypeSet[data.templateFlag]) {
            const issueItem = IssueTypeSet[data.templateFlag];
            type = issueItem.type || ComponentTypeEnum.Dialog;
            issueTypeItem = issueItem;
            compDirName = issueItem.templateFlag;
            chatContentData = issueItem.children;
            robotMessage = issueItem.templateName;
            break;
          }
          break;
        case ReplyActionEnum.selectQuestion:
          compDirName = TemplateFlagEnum.SelectQuestion;
          chatContentData = data.questions;
          break;
      }
      const config: {
        type: ComponentTypeEnum;
        message: string;
        id: string;
        issueTypeItem: IssueItemType | null;
        showSubmitTicket?: boolean;
        feedback?: boolean;
        templateFlag?: number | string;
        parentContentInfo?: {
          parentContent: string;
          parentContentId: string;
          parentContentType: ReportParentContentEnum;
        };
        questionName?: string;
        rootSourceType?: TagTypeEnum;
      } = {
        type,
        message: robotMessage || customerMessage,
        id: params.id || NoFoundKnowledgeId,
        issueTypeItem,
        showSubmitTicket: !dialog,
        templateFlag: data.templateFlag || "",
        questionName,
        rootSourceType,
      };
      if (ReplyActionEnum.answerQuestion === data.action) {
        config.feedback = true;
      }
      if (parentContentInfo && Object.keys(parentContentInfo).length) {
        config.parentContentInfo = parentContentInfo;
      }
      const chatContent: ChatContentType[] = [
        requireRobotQuestionParams(chatContentData, compDirName, config),
      ];
      if (type !== ComponentTypeEnum.Dialog) {
        chatContent.unshift(requireCustomerQuestionParams(customerMessage));
      }
      return Promise.resolve(chatContent);
    }
  } catch (err) {
    return Promise.reject(err);
  }
}
